import { api } from "../lib";

export type CalculationBasis = "cpt_code" | "block" | "slide";

export interface LabPaymentAgreement {
  id: string;
  practiceId: string;
  practice?: { id: string; name: string };
  calculationBasis: CalculationBasis;
  flatRate: number | null;
  isActive: boolean;
  notes: string | null;
  rates?: LabPaymentRate[];
  createdAt: string;
  updatedAt: string;
}

export interface LabPaymentRate {
  id: string;
  agreementId: string;
  cptCodeId: string;
  cptCode?: { id: string; code: string; description: string };
  rate: number;
}

export interface CreateAgreementDto {
  practiceId: string;
  calculationBasis: CalculationBasis;
  flatRate?: number | null;
  notes?: string | null;
}

export interface UpdateAgreementDto {
  calculationBasis?: CalculationBasis;
  flatRate?: number | null;
  notes?: string | null;
  isActive?: boolean;
}

export interface CreateRateDto {
  cptCodeId: string;
  rate: number;
}

export interface UpdateRateDto {
  rate: number;
}

export const labPaymentAgreementsService = {
  listAgreements: (): Promise<LabPaymentAgreement[]> =>
    api.get<LabPaymentAgreement[]>("/reports/lab-payment-agreements"),

  createAgreement: (dto: CreateAgreementDto): Promise<LabPaymentAgreement> =>
    api.post<LabPaymentAgreement>("/reports/lab-payment-agreements", dto),

  getAgreement: (id: string): Promise<LabPaymentAgreement> =>
    api.get<LabPaymentAgreement>(`/reports/lab-payment-agreements/${id}`),

  updateAgreement: (
    id: string,
    dto: UpdateAgreementDto
  ): Promise<LabPaymentAgreement> =>
    api.put<LabPaymentAgreement>(`/reports/lab-payment-agreements/${id}`, dto),

  deleteAgreement: (id: string): Promise<void> =>
    api.delete<void>(`/reports/lab-payment-agreements/${id}`),

  listRates: (agreementId: string): Promise<LabPaymentRate[]> =>
    api.get<LabPaymentRate[]>(
      `/reports/lab-payment-agreements/${agreementId}/rates`
    ),

  createRate: (
    agreementId: string,
    dto: CreateRateDto
  ): Promise<LabPaymentRate> =>
    api.post<LabPaymentRate>(
      `/reports/lab-payment-agreements/${agreementId}/rates`,
      dto
    ),

  updateRate: (
    agreementId: string,
    rateId: string,
    dto: UpdateRateDto
  ): Promise<LabPaymentRate> =>
    api.put<LabPaymentRate>(
      `/reports/lab-payment-agreements/${agreementId}/rates/${rateId}`,
      dto
    ),

  deleteRate: (agreementId: string, rateId: string): Promise<void> =>
    api.delete<void>(
      `/reports/lab-payment-agreements/${agreementId}/rates/${rateId}`
    ),
};
